import React from 'react';
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import * as Sentry from '@sentry/browser';
import { googleOauth } from 'customer/context';
import { baseUrl } from 'config';
import VError from 'verror';
import { setUserAuthorization, setUserAuthentication } from '../../hooks/sessionTokens';
import './index.scss';

export const OAUTH_ERROR_MESSAGES = {
  popup_closed_by_user: 'Please complete the Google sign in flow. If you were not prompted to choose a Google account, please make sure to disable your popup blocker.',
  idpiframe_initialization_failed: 'Initialization of the Google Auth API failed. Please make sure third party cookies are enabled and you have disabled any popup blockers or extensions that may block data for this site or https://accounts.google.com.',
  immediate_failed: 'No user could be automatically selected without prompting the consent flow.',
  access_denied: 'Rackspace requires access to your Google Cloud Platform resources. If you are unable to grant Rackspace access, please contact support for help setting up your Managed Services for Google Cloud Platform account.',
};
export const OAUTH_DEFAULT_ERROR_MESSAGE = 'Unable to connect to your Google account.';

export const GoogleSignInButton = ({ setError } = {}) => {
  const history = useHistory();
  const { setGoogleOauthStatus } = React.useContext(googleOauth) || {};

  const successAuthorization = (tokenResponse) => {
    setUserAuthorization(tokenResponse);
    return _.isFunction(setGoogleOauthStatus) ? setGoogleOauthStatus(new Date()) : history.push('/gcp/onboarding');
  };

  const handleAuthorizationError = (error) => {
    throw new VError({ name: 'Google Authorization', cause: error },
      'Unable to generate access token');
  };

  const googleAuthorize = useGoogleLogin({
    onSuccess: successAuthorization,
    onError: handleAuthorizationError,
    scope: 'https://www.googleapis.com/auth/cloud-platform',
  });

  const onSuccess = (response) => {
    setUserAuthentication(response);
    googleAuthorize();
  };

  const onFailure = (response) => {
    if (response.error) {
      if (_.isFunction(setError)) {
        setError(_.get(OAUTH_ERROR_MESSAGES, response.error, OAUTH_DEFAULT_ERROR_MESSAGE));
      }
      Sentry.captureException(response.error);
    }
  };

  return (
    <div>
      <GoogleLogin onSuccess={onSuccess} onError={onFailure} auto_select useOneTap use_fedcm_for_button width={195} type="standard" size="large" shape="square" text="signin_with" theme="outline" />

      <blockquote className="pop-up-note">
        <p>
          <strong>Note:</strong>
          {' '}
          Please make sure to
          {' '}
          <strong>enable pop-ups</strong>
          {' '}
          for
          {' '}
          { baseUrl() }
          {' '}
        </p>
        <p>
          If you have issues opening pop-ups windows
          {' '}
          <button type="button" className="authorize-button" onClick={googleAuthorize}> click here</button>
        </p>
      </blockquote>
    </div>
  );
};
